import {
  POST_VALIDATION_SESSION_KONSELING_FAIL,
  POST_VALIDATION_SESSION_KONSELING_REQUEST,
  POST_VALIDATION_SESSION_KONSELING_RESET,
  POST_VALIDATION_SESSION_KONSELING_SUCCESS,
} from "../constants/ValidationSessionKonselingConstants";

export const km_post_validation_sesssion_konseling_reducers = (
  state = { data: {} },
  action
) => {
  switch (action.type) {
    case POST_VALIDATION_SESSION_KONSELING_REQUEST:
      return { loading: true };
    case POST_VALIDATION_SESSION_KONSELING_SUCCESS:
      return { loading: false, data: action.payload, success: true };
    case POST_VALIDATION_SESSION_KONSELING_FAIL:
      return { loading: false, error: action.payload };
    case POST_VALIDATION_SESSION_KONSELING_RESET:
      return {};
    default:
      return state;
  }
};
